var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAuthenticated)?_c('v-card',{staticClass:"user-delivery-service-block navbar-address-selector-opener ma-3 pl-2 py-1 d-flex d-md-none align-center",style:(_vm.style),attrs:{"outlined":""}},[_c('navbar-delivery-service',{attrs:{"shippingAddress":_vm.shippingAddress}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }